import script from "./BasePageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePageLoader.vue?vue&type=script&setup=true&lang=ts"

import "./BasePageLoader.vue?vue&type=style&index=0&id=8a654c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a654c20"]])

export default __exports__